import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    componentDidMount() {
        if (/apple/i.test(navigator.vendor) && (!this.props.decks || this.props.decks.length == 0)) {
            setTimeout(() => {
                this.props.loadDecks();
            }, 250);
        }
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps != this.props) {
            return true;
        }

        return false;
    }

    render({ deck, decks, user, message }) {
        let [category, action, label] = [
            'Tarot Readings',
            user.logged_in ? 'LI Click' : 'LO Click',
            'Deck Selector Dropdown',
        ];
        if (this.props['data-ga-event'] != undefined) {
            category = this.props['data-category'];
            label = this.props['data-label'];
        }

        if (deck.code != 'mandala') {
            if (decks && decks.length > 0) {
                const preselect = this.shouldPreselectDeck();

                return (
                    <select
                        onFocus={() => {
                            this.props.trackEvent([category, action, label]);
                        }}
                        onChange={(e) => {
                            this.props.trackEvent([category, action, 'Deck Selector Change']);
                            this.props.changeDeck(e);
                        }}
                        onClick={this.click}
                        message={message}
                    >
                        {message ?
                            <option disabled selected>{message}</option>
                            :
                            <option disabled {...preselect ? {} : { selected: true }}>Choose a Deck</option>
                        }
                        {decks.map((deck) => {
                            const selected = !message && this.props.deck.code == deck.code && preselect
                                ? { selected: true } : {};

                            return deck.type == 'tarot'
                                ?
                                (<option value={deck.code} {...selected}>{deck.name}</option>)
                                :
                                null;
                        })}
                    </select>
                );
            }

            return (
                <select
                    onFocus={() => {
                        this.props.trackEvent([category, action, label]);
                        this.props.loadDecks();
                    }}
                    onClick={this.click}
                    message={message}
                >
                    {this.shouldPreselectDeck()
                        ?
                        <option value={this.props.deck.code} selected>{this.props.deck.name}</option>
                        :
                        <option disabled selected>{message ? message : 'Choose a Deck'}</option>
                    }
                </select>
            );
        }

        return null;
    }

    shouldPreselectDeck = () => {
        return this.props.deck.deck != 34
            ||
            (this.props.user.logged_in && this.props.user.favorite_deck_id != 0)
            ||
            (Object.keys(this.props.query).some(q => (['report', 'deck']).includes(q)));
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    decks: state.decks,
    user: state.user,
    query: state['query-params'],
});

const mapDispatchToProps = (dispatch) => ({
    changeDeck: (e) => dispatch({ type: 'deck:required', payload: e.target.value }),
    loadDecks: () => dispatch({ type: 'decks:required' }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
